import React, { useState, useRef } from 'react'
import { useInView } from 'framer-motion'

import { Container } from '../../Container'

import './tour-component.css'
import ContentfulLongText from '../../ContentfulLongText'

export const TourComponent = ({ sectionVisibility, content, coffeePackagingTour, partsLists }) => {
    const [hoveredDotImage, setHoveredDotImage] = useState(null);

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const handleHover = (dotItem) => {
        setHoveredDotImage(dotItem);
    };

    const hasMatchingLanguage = coffeePackagingTour?.some(
        (item) => item.node.language === content.pageLanguage
    );

    const tourFilter = coffeePackagingTour?.filter((item) => {
        if (hasMatchingLanguage) {
          return item.node.language === content.pageLanguage;
        } else {
          return item.node.language === null;
        }
    });

    console.log(partsLists)

    if(sectionVisibility) {
        return (
            <div className='relative block bg-frost-white'>
                <Container>
                    <div ref={ref} className="content-tour">
                        <div className="main-tour-image"><img src={partsLists.image.gatsbyImageData.images.fallback.src} alt={partsLists.title || 'Page Body Media'} /></div>
                        <div className="tour-detail">
                            {partsLists?.lists.map((item, index) => (
                                <div 
                                    key={index} 
                                    style={{
                                    opacity: isInView ? 1 : 0,
                                    transition: `all ${isInView ? 0.9 * index : 0}s cubic-bezier(0.17, 0.55, 0.55, 1) ${isInView ? 0.9 * index : 0}s`
                                    }}
                                    className="tour-detail-item"
                                    onMouseEnter={() => handleHover(index)}
                                    onMouseLeave={() => handleHover(null)}
                                    role="button" 
                                    tabIndex={0} 
                                    onClick={() => {}}
                                    onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') {}}}
                                >
                                    {item.image && <div className="dot-image"><div className={`anim--pulsate ${hoveredDotImage === index &&  'd-none'}`}></div></div>}
                                    <div className={`tour-details ${hoveredDotImage === index && 'tour-details--active'}`}>
                                        {item.title && <ContentfulLongText longTextContent={item.title} classNameProp="whitespace--prewrap text-4xl text--dark mb-10 family-open-sans weight--normal"/>}
                                        {item?.description?.description && <ContentfulLongText longTextContent={item?.description?.description} classNameProp='text-12' />}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
                {/* <Container>
                    <div ref={ref} className="content-tour">
                        <div className="main-tour-image"><img src={content.coffeePackagingTourImage} alt={content.pageTitle || 'Page Body Media'} /></div>
                        <div className="tour-detail">
                            {tourFilter.map((tourDetail, index) => (
                                <div 
                                    key={index} 
                                    style={{
                                    opacity: isInView ? 1 : 0,
                                    transition: `all ${isInView ? 0.9 * index : 0}s cubic-bezier(0.17, 0.55, 0.55, 1) ${isInView ? 0.9 * index : 0}s`
                                    }}
                                    className="tour-detail-item"
                                    onMouseEnter={() => handleHover(index)}
                                    onMouseLeave={() => handleHover(null)}
                                    role="button" 
                                    tabIndex={0} 
                                    onClick={() => {}}
                                    onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') {}}}
                                >
                                    {tourDetail.node.hasDotImage && <div className="dot-image"><div className={`anim--pulsate ${hoveredDotImage === index &&  'd-none'}`}></div></div>}
                                    <div className={`tour-details ${hoveredDotImage === index && 'tour-details--active'}`}>
                                        {tourDetail.node.tourTitle && <h3 className="whitespace--prewrap text--dark mb-10 family-open-sans weight--normal" dangerouslySetInnerHTML={{ __html: tourDetail.node.tourTitle.tourTitle }} />}
                                        <p>{tourDetail.node.description.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container> */}
            </div>
        )
    } else return null
}